import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLParagraphElement>["className"];
  id?: HTMLAttributes<HTMLParagraphElement>["id"];
  listStyleType?: CSSProperties["listStyleType"];
  style?: CSSProperties;
}>;

export default function UL({
  children,
  className,
  id,
  listStyleType,
  style,
}: Props) {
  return (
    <ul className={className} id={id} style={{ ...style, listStyleType }}>
      {children}
    </ul>
  );
}
